import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-ticket-history',
  templateUrl: './ticket-history.component.html',
  styleUrls: ['./ticket-history.component.scss']
})
export class TicketHistoryComponent implements OnInit {

  dataArray: any[] = [];
  officePurpose: any;
  isTicket: any;

  constructor(
    public dialogRef: MatDialogRef<TicketHistoryComponent>,
    public dialogRef1: MatDialogRef<TicketHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public service: WebRequestService
  ) { 
    this.dataArray = data[0].mainData;
    this.officePurpose = data[0].isOffice;
    this.isTicket = data[0].isTicket;
  }

  ngOnInit(): void {
    console.log(this.dataArray,this.isTicket,this.officePurpose)
  }


  onNoClick() {
    this.dialogRef.close();
  }

}
